<template>
  <div class="navigation-main-container">
    <nav class="navbar navbar-expand-lg" :class="{opened : Active}">
      <router-link class="navbar-brand" to="/home">
        <img src="../assets/misc/logo.png" alt />
      </router-link>
      <div class="overlay"></div>
      <a class="menu-toggler" ref="MenuTogglerBtn">
        <div
          class="menu__item--hamburger navbar-toggler"
          :class="{active : Active , collapsed  : !Active}"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="ToggleMeneButton"
        >
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </a>

      <div class="collapse navbar-collapse" id="navbarSupportedContent" ref="navContainer">
        <div
          class="nav-overlay"
          v-touch:swipe.top.self="SliderSwipped"
          v-touch:start="SliderTouchStart"
          v-touch:end="SliderTouchEnd"
          v-touch-options="{swipeTolerance: 150}"
        ></div>
        <ul class="navbar-nav" v-touch:start="SliderTouchStart" v-touch:end="SliderTouchEnd">
          <router-link
            to="/home"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'home'}"
            data-target=".navbar-collapse.show"
          >
            <li class="nav-item" @click="Active = false">
              <i class="fas fa-home"></i> Home
            </li>
          </router-link>
          <router-link
            to="/achievements"
            data-toggle="collapse"
            :class="{active : ActiveRoute === 'achievements'}"
            data-target=".navbar-collapse.show"
          >
            <li class="nav-item" @click="Active = false">
              <i class="fas fa-trophy"></i>
              Achievements
            </li>
          </router-link>
          <router-link
            to="/tools"
            data-toggle="collapse"
            data-target=".navbar-collapse.show"
            :class="{active : ActiveRoute === 'tools'}"
          >
            <li class="nav-item" @click="Active = false">
              <i class="fas fa-wrench"></i>
              Tools
            </li>
          </router-link>
          <router-link
            to="/about"
            data-toggle="collapse"
            data-target=".navbar-collapse.show"
            :class="{active : ActiveRoute === 'about'}"
          >
            <li class="nav-item" @click="Active = false">
              <i class="far fa-address-card"></i>
              About
            </li>
          </router-link>
          <router-link
            to="/contact"
            data-toggle="collapse"
            data-target=".navbar-collapse.show"
            :class="{active : ActiveRoute === 'contact'}"
          >
            <li class="nav-item" @click="Active = false">
              <i class="fas fa-envelope-square"></i>
              Contact
            </li>
          </router-link>
        </ul>
        <div
          class="bottom-slider"
          v-touch:swipe.top.self="SliderSwipped"
          v-touch:start="SliderTouchStart"
          v-touch:end="SliderTouchEnd"
          v-touch-options="{swipeTolerance: 150}"
        >
          <i class="fas fa-ellipsis-h"></i>
        </div>
      </div>
    </nav>
    <nextPagePreviosPageButtons :style="{zIndex :Active ? '99998' : '99999'  }" />
  </div>
</template>

<script>
import nextPagePreviosPageButtons from "./nextPagePreviosPageButtons";

export default {
  components: {
    nextPagePreviosPageButtons,
  },
  mounted: function () {
    this.$router.afterEach(() => {
      this.ActivateCurrentRoute();
    });
  },
  data() {
    return {
      Active: false,
      ActiveRoute: null,
      SliderTouched: false,
    };
  },
  methods: {
    ToggleMeneButton: function () {
      if (this.Active) {
        this.Active = false;
      } else {
        this.Active = true;
      }
    },
    CloseNavBar: function () {
      this.$refs.MenuTogglerBtn.querySelector(".menu__item--hamburger").click();
    },
    ActivateCurrentRoute: function () {
      let currentPathName = this.$route.path.replace("/", "").toLowerCase();
      this.ActiveRoute = currentPathName;
    },

    SliderSwipped: function () {
      this.CloseNavBar();
    },
    SliderTouchStart: function () {
      // stop body from sliding while active
      this.ToggleLockBody(true);
    },
    SliderTouchEnd: function () {
      // stop body from sliding while active
      this.ToggleLockBody(false);
    },
    ToggleLockBody: function (lockOrUnLock) {
      if (lockOrUnLock) document.body.classList.add("locked");
      else {
        // prevent body scrolling while swipping the list
        setTimeout(function () {
          document.body.classList.remove("locked");
        }, 200);
      }
    },
  },
  created: function () {
    this.ActivateCurrentRoute();
  },
};
</script>

<style>
.navbar {
  width: 100%;
  z-index: 99999;
  padding: 0px;
  position: absolute;
}

.navbar-nav {
  padding: 30px;
}
.navbar a {
  color: white;
  text-decoration: none;
  cursor: pointer;
}
.navbar a.active,
.navbar a.active li,
.navbar a.active i {
  font-weight: bold;
  color: #ff5f96;
}

.navbar a:hover {
  text-decoration: none;
  cursor: pointer;
}

.navbar li {
  color: white;
  margin-left: 40px;
  padding-bottom: 3px;
  transition: border-bottom 0.3s;
  border-bottom: 2px solid transparent;
}
.navbar li:hover {
  border-bottom: 2px solid #ff5f96;
}

li.nav-item i {
  color: white;
  margin-right: 10px;
}

.menu-toggler {
  position: absolute;
  font-size: 30px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  position: absolute;
  top: 27px;
  right: 22px;
}

.menu__item--hamburger {
  width: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.menu__item--hamburger {
  outline: none;
  z-index: 999;
}

.line,
.box {
  transition: all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.line {
  height: 2px;
  width: 40px;
  background: #adc9ce;
  margin: 3px auto;
}

.menu__item--hamburger.active .line:nth-child(1) {
  transform: rotate(45deg) translate(3px, 6px);
}

.menu__item--hamburger.active .line:nth-child(2) {
  visibility: hidden;
}

.menu__item--hamburger.active .line:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -9px);
}

.bottom-slider {
  background-color: #404040;
  text-align: center;
  color: white;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  display: none;
}

.overlay {
  display: none;
}

.navbar-brand {
  margin-left: 50px !important;
}

.nav-overlay {
  display: none;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .navbar-nav {
    background-color: rgb(24, 28, 33);
    padding: 0px;
    padding-top: 15px;
    padding-bottom: 20px;
  }

  .navbar-nav a {
    padding-top: 13px;
    padding-bottom: 10px;
    padding-left: 15px;
  }

  .navbar.navbar-expand-lg {
    position: fixed;
  }
  .navbar a,
  .navbar li {
    margin-left: initial;
  }

  .navbar a.active {
    background-color: #22272d;
  }

  .navbar a.active li {
    color: #ff5f96;
  }

  .bottom-slider {
    display: initial;
  }
  body.locked .bottom-slider {
    background-color: #353535;
  }

  body.locked .bottom-slider i {
    color: #adc9ce;
  }

  .navbar.navbar-expand-lg {
    position: fixed;
    /* background-color: rgba(18, 18, 18, 0.37); */
    padding-bottom: 11px;
  }

  .navbar.navbar-expand-lg.opened .overlay {
    background-color: #181c21;
  }

  .Scrolled .overlay {
    background-color: rgb(24, 28, 33);
  }

  .overlay {
    display: block;
    /* background-color: rgba(18, 18, 18, 0.1); */
    height: 69px;
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: -1;
    -webkit-transition: background-color 0.5s linear;
    -ms-transition: background-color 0.5s linear;
    transition: background-color 0.5s linear;
  }

  .menu-toggler {
    top: 18px;
    right: 4px;
  }

  .navbar-brand {
    margin-top: 10px;
    margin-left: 18px !important;
  }

  .navbar-brand img {
    height: 38px;
  }

  .nav-overlay {
    display: block;
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #181c21;
    opacity: 0.9;
    z-index: -1;
  }
}
</style>